import {FormatInterface} from './FormatInterface';
import {BaseFormatter} from './BaseFormatter';
import Decimal from 'decimal.js';

export class NumberFormatter extends BaseFormatter<number>{
	private unit: string = null;
	private readExp:RegExp;

	constructor(format: FormatInterface, unit: string = null) {
		super(format);

		this.unit = unit;
		this.readExp = new RegExp(`[^0-9-\\${this.format.numbers.decimalSeparator}]`, 'g');
	}

	public getUnit(): string {
		return this.unit;
	}

	public read(value: string): number {
		value = value.replace(this.readExp, '');
		value = value.replace(/(?!^)-/, '');
		const valueArray = value.split(this.format.numbers.decimalSeparator);
		if(valueArray.length > 1) {
			value = valueArray.shift() + '.' + valueArray.join('');
		}
		try {
			return new Decimal(value).toNumber();
		} catch(e) {
			return 0;
		}
	}

	public render(value: number, wholeNumberOnly: boolean = false):string {
		let stringArray:string[] = [];
		const decimal = new Decimal(value);
		let num = decimal.toDecimalPlaces(this.format.numbers.decimalAccuracy);

		if(this.format.numbers.isDecimal && !wholeNumberOnly) {
			if(this.format.numbers.decimalAccuracy > 0) {
				stringArray.push(num.toFixed(this.format.numbers.decimalAccuracy).split('.')[1]);
			}
		}

		if(this.format.numbers.isGrouped) {
			let a = num.truncated().valueOf().replace('-', '').split('').reverse();
			let b:string[] = [];
			for(let i = 0; i < a.length; i++) {
				if(i > 0 && i % this.format.numbers.groupSize === 0) {
					b.push(this.format.numbers.groupSeparator);
				}

				b.push(a[i]);
			}

			if(decimal.isNegative()) {
				b.push('-');
			}

			stringArray.push(b.reverse().join(''));
		} else {
			stringArray.push(value.toString());
		}
		const separator = wholeNumberOnly ? '' : this.format.numbers.decimalSeparator;
		let numberPart = [stringArray.reverse().join(separator)];

		if(this.unit) {
			numberPart.push(this.unit);
			if(this.format.unit.beforeAmount) {
				numberPart.reverse();
			}
		}

		return numberPart.join(' ');
	}
};
